import React, { useEffect, useState } from 'react';
import Header from '../../../common/Header/Header';
import ErrorAlert from '../../../common/Alert/ErrorAlert';
import SuccessAlert from '../../../common/Alert/SuccessAlert';
import IndividualSale from './IndividualSale';
import BulkSale from './BulkSale';

const identity_host = process.env.REACT_APP_IDENTITY_HOST;

export default function CreateSale() {
    const [iserror,setIsError] = useState(false);
    const [issuccess,setIsSuccess] = useState(false);
    const [message,setMessage] = useState("");
    const [saleContext,setSaleContext] = useState(null);
    const [saleType,setSaleType] = useState("individual");

    useEffect(()=>{
        fetch(identity_host+'/centralized/salesTrackingForm/context/')
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            console.log('Received data:', data);
            setSaleContext(data);
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    },[])

    return (
        <>
            <Header />
            {iserror && <ErrorAlert message={message} setIsError={setIsError} />}
            {issuccess && <SuccessAlert message={message} />}
            
            <section id='postSales' className='common-style background-dark-primary min-vh-100'>
              <div className='container py-5 px-5'>
                <div className='row d-flex justify-content-center align-items-center'>
                  <div className='col-lg-9'>
                    <div className="card p-4 border-0 shadow background-dark-secondary mb-4">
                      <div className="card-body">
                        <h1 className='text-white fs-20 mb-3'>Sale Type</h1>
                        <div className="d-flex">
                          <div className="form-check me-4">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="saleType"
                              id="individualRadio"
                              value="individual"
                              checked={saleType === "individual"}
                              onChange={(e) => setSaleType(e.target.value)}
                            />
                            <label className="form-check-label text-white pointer" htmlFor="individualRadio">
                              Individual
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="saleType"
                              id="bulkRadio"
                              value="bulk"
                              checked={saleType === "bulk"}
                              onChange={(e) => setSaleType(e.target.value)}
                            />
                            <label className="form-check-label text-white pointer" htmlFor="bulkRadio">
                              Bulk
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {saleType === "individual" ? (
                      <IndividualSale saleContext={saleContext} saleType={saleType} />
                    ) : (
                      <BulkSale saleContext={saleContext} saleType={saleType} />
                    )}
                  </div>
                </div>
              </div>
            </section>
        </>
    )
}
  